/* tslint:disable */
/* eslint-disable */
/**
 * Wings Server
 * A backend for birds database.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: li3p@xmbirds.cn
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaxonomyPortraitNode
 */
export interface TaxonomyPortraitNode {
    /**
     * 
     * @type {number}
     * @memberof TaxonomyPortraitNode
     */
    node: number;
    /**
     * 
     * @type {number}
     * @memberof TaxonomyPortraitNode
     */
    taxonomy: number;
}

export function TaxonomyPortraitNodeFromJSON(json: any): TaxonomyPortraitNode {
    return TaxonomyPortraitNodeFromJSONTyped(json, false);
}

export function TaxonomyPortraitNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxonomyPortraitNode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'node': json['node'],
        'taxonomy': json['taxonomy'],
    };
}

export function TaxonomyPortraitNodeToJSON(value?: TaxonomyPortraitNode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'node': value.node,
        'taxonomy': value.taxonomy,
    };
}


